import { useRef as n, useEffect as t, useState as r } from "react";
export default function (u) {
  void 0 === u && (u = 250);
  var c = n(null),
      e = r(0),
      o = e[0],
      i = e[1];
  return function (r, u) {
    var c = n(function () {
      return r;
    });
    t(function () {
      c.current = r;
    }), t(function () {
      if (null !== u) {
        var n = setInterval(function () {
          c.current();
        }, u);
        return function () {
          return clearInterval(n);
        };
      }
    }, [u]);
  }(function () {
    try {
      i(c.current.contentWindow.document.body.scrollHeight);
    } catch (n) {}
  }, u), [c, o];
}